import { useState } from "react";
import { useParams } from "react-router-dom";
import { completeWfSetupTask, patchWfSourceConfig } from "../../../Moduels/attendance/wfApi";

const PRESETS = {
  geo_fence: { latitude: 0, longitude: 0, radius_meters: 100, policy_configured: true },
  mobile_checkin: { gps_required: true, selfie_required: false, policy_configured: true },
  qr: { qr_enabled: true, branch_code: "MAIN", expiry_minutes: 15 },
  face_scan: { enrollment_required: true, confidence_threshold: 0.85 },
  excel_upload: { template_configured: true, column_mapping: { employee_code: "A", date: "B", status: "C" } },
  default_present: { default_status: "present", policy_configured: true, absent_override: true },
  browser_login: { web_portal_enabled: true, policy_configured: true, allow_self_mark: true },
};

const TASK_BY_SOURCE = {
  geo_fence: "CONFIGURE_GEOFENCE",
  mobile_checkin: "CONFIGURE_MOBILE",
  qr: "CONFIGURE_QR",
  face_scan: "CONFIGURE_FACE_SCAN",
  excel_upload: "CONFIGURE_EXCEL_IMPORT",
  default_present: "CONFIGURE_DEFAULT_PRESENT",
  browser_login: "CONFIGURE_WEB_LOGIN",
};

export default function WfSourceConfig() {
  const { sourceCode } = useParams();
  const [settings, setSettings] = useState(PRESETS[sourceCode] || {});
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const onSave = async () => {
    setErr("");
    try {
      await patchWfSourceConfig(sourceCode, { enabled: true, settings_json: settings });
      setMsg("Configuration saved.");
    } catch (e) {
      setErr(typeof e?.response?.data?.detail === "string" ? e.response.data.detail : e?.response?.data?.detail?.message || e.message);
    }
  };

  const onComplete = async () => {
    const code = TASK_BY_SOURCE[sourceCode];
    if (!code) return;
    try {
      await completeWfSetupTask(code);
      setMsg("Task validated and completed.");
    } catch (e) {
      setErr(typeof e?.response?.data?.detail === "string" ? e.response.data.detail : e?.response?.data?.detail?.message || e.message);
    }
  };

  return (
    <div className="p-6 w-full max-w-full min-w-0">
      <h1 className="text-2xl font-semibold mt-2 mb-2">Configure: {sourceCode}</h1>
      <p className="text-sm text-gray-500 mb-4">Operational settings stored on organisation source config (not payroll).</p>
      {msg && <p className="text-green-700 text-sm mb-2">{msg}</p>}
      {err && <p className="text-red-700 text-sm mb-2">{String(err)}</p>}

      <textarea
        className="w-full border rounded-lg p-3 font-mono text-xs h-48 mb-4"
        value={JSON.stringify(settings, null, 2)}
        onChange={(e) => {
          try {
            setSettings(JSON.parse(e.target.value));
          } catch {
            /* ignore while typing */
          }
        }}
      />

      <div className="flex gap-3">
        <button type="button" onClick={onSave} className="px-4 py-2 bg-gray-800 text-white rounded-lg text-sm">
          Save settings
        </button>
        <button type="button" onClick={onComplete} className="px-4 py-2 bg-teal-600 text-white rounded-lg text-sm">
          Validate & complete task
        </button>
      </div>
    </div>
  );
}
